import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

//Servicios
import { EstacionesService } from '@/app/services/estaciones.service';

//Modelos

//Librerías externas
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-editar-estaciones',
    templateUrl: './editar-estaciones.component.html',
    styleUrls: ['./editar-estaciones.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditarEstacionesComponent {
  private spinner = inject(NgxSpinnerService);

  //Ng-model
  EstacionRQ = {
    idEstacion: null,
    IATA: null,
    descripcion: null,
  };

  //Bandera auxiliar (Mostrar / ocultar campo de tipo usuario)
  motrarTipoEstacion: boolean = false;

  //Bandera global para cerrar el modal
  hasFinished: boolean = false;

  constructor(
    private EstacionesService: EstacionesService,
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<EditarEstacionesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    let {
      idEstacion,
      IATA,
      descripcion
    } = data;

    this.EstacionRQ.idEstacion = idEstacion;
    this.EstacionRQ.IATA = IATA;
    this.EstacionRQ.descripcion = descripcion;
  }

  //Submit y crear usuario
  formSubmit(form: NgForm) {
    if (form.valid) {
      Swal.fire({
        title: 'Confirmar',
        text: '¿Deseas actualizar esta estación?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor: '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.actualizarEstacion();
        }
      });
    }
  }

  actualizarEstacion() {
    this.spinner.show();

    this.EstacionesService.actualizarEstacion(this.EstacionRQ).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Estación actualizada correctamente.',
          'success'
        ).then((result) => {
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) => {
        this.spinner.hide();

        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ExceptionMessage } = err.error;
            this.toastr.error(
              ExceptionMessage
                ? ExceptionMessage
                : 'Se ha producido un error al obtener lista de tipos de usuario.',
              'Error'
            );
          }
        }
        console.log(err);
      },
    });
  }

  onClose() {
    if (!this.hasFinished) {
      Swal.fire({
        title: 'Alerta',
        text: 'No se han guardado los cambios. ¿Seguro que deseas salir?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor: '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false,
      }).then((result) => {
        if (result.value) {
          this.dialogRef.close({ updateList: false });
        }
      });
    } else {
      this.dialogRef.close({ updateList: true });
    }
  }
}
